/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  GetActivityLogRequest,
  GetActivityLogSuccess,
  GetActivityLogError,
  GetActivityLogPending,
  ActivityLogActionTypes,
  ActivityLogState,
  GetKioskLatestActivitySuccess,
  GetKioskLatestActivityPending,
  GetKioskLatestActivityError
} from './types';

// Actions
export const actions = {
  getActivityLog: (payload: GetActivityLogRequest['payload']): ActivityLogActionTypes => ({
    type: types.GET_ACTIVITY_LOG.REQUEST,
    payload
  }),
  resetActivityLog: (): ActivityLogActionTypes => ({ type: types.RESET_ACTIVITY_LOG }),
  resetExportData: (): ActivityLogActionTypes => ({ type: types.RESET_EXPORT_DATA }),
  getKioskLatestActivityLog: (payload: { kioskId: string }): ActivityLogActionTypes => ({
    type: types.GET_KIOSK_LATEST_ACTIVITY_LOG.REQUEST,
    payload
  })
};

// Initial State
export const initialState: ActivityLogState = {
  activityLog: [],
  totalRecords: 1,
  hasMore: false,
  pending: false,
  error: null,
  export: {
    data: [],
    pending: false
  },
  latestKioskActivityLog: {
    kioskEvents: [],
    kioskHardwareEvents: [],
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (state: ActivityLogState = initialState, action: ActivityLogActionTypes): ActivityLogState => {
  return produce(state, (draft) => {
    let payload;
    switch (action.type) {
      case types.GET_ACTIVITY_LOG.PENDING:
        payload = (action as GetActivityLogPending).payload;
        if (payload.exportData) {
          draft.export.pending = payload.pending;
        } else {
          draft.pending = payload.pending;
        }
        break;
      case types.GET_ACTIVITY_LOG.SUCCESS:
        payload = (action as GetActivityLogSuccess).payload;
        if (payload.exportData) {
          draft.export.data = payload.data;
        } else {
          draft.activityLog = [...draft.activityLog, ...payload.data];
          draft.hasMore = draft.activityLog.length < payload.total;
          draft.totalRecords = payload.total;
        }
        draft.error = null;
        break;
      case types.GET_ACTIVITY_LOG.ERROR:
        draft.error = (action as GetActivityLogError).payload;
        break;
      case types.RESET_ACTIVITY_LOG:
        draft.activityLog = initialState.activityLog;
        draft.hasMore = initialState.hasMore;
        draft.pending = initialState.pending;
        draft.error = initialState.error;
        break;
      case types.RESET_EXPORT_DATA:
        draft.export.data = initialState.export.data;
        break;
      case types.GET_KIOSK_LATEST_ACTIVITY_LOG.PENDING:
        draft.latestKioskActivityLog.pending = (action as GetKioskLatestActivityPending).payload;
        break;
      case types.GET_KIOSK_LATEST_ACTIVITY_LOG.SUCCESS:
        draft.latestKioskActivityLog.kioskEvents = (action as GetKioskLatestActivitySuccess).payload.kioskEvents;
        draft.latestKioskActivityLog.kioskHardwareEvents = (
          action as GetKioskLatestActivitySuccess
        ).payload.kioskHardwareEvents;
        draft.error = null;
        break;
      case types.GET_KIOSK_LATEST_ACTIVITY_LOG.ERROR:
        draft.latestKioskActivityLog.error = (action as GetKioskLatestActivityError).payload;
        break;
    }
  });
};
